import React from 'react';
import PropTypes from 'prop-types';
import css from './RadioButton.scss'

const RadioButton = ({ label, disabled, ...inputProps }) => {
  return (
    <div className={css['radiobutton-wrapper']}>
      <label className={`${css['radiobutton']} ${disabled ? css['disabled'] : ''}`}>
        <input
          type="radio"
          disabled={disabled}
          {...inputProps}
        />
       <span className={css['radiobutton-label']}>{label}</span>
      </label>
    </div>
  )
}

RadioButton.propTypes = {
  value: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
}
export default RadioButton
